<template>
	<div ref="app" id="app" :style="{width: baseWidth + 'px', height: '100%'}">
		<!-- <Transition name="fade-right" mode="out-in"> -->
		<KeepAlive>
			<router-view />
		</KeepAlive>
		<!-- </Transition> -->
	</div>
</template>

<script>
export default {
	name: 'App',
	data() {
		return {
			baseWidth: 1920
		};
	},
	mounted() {
		this.resize();
		window.addEventListener('resize', this.resize);
	},
	// 销毁监听
	beforeDestroy() {
		window.removeEventListener('resize', this.resize);
	},
	methods: {
		resize() {
			let root = this.$refs.app;
			const scale = {
				width: '1',
				height: '1'
			};

			// 只根据宽度进行计算缩放比例
			const baseWidth = this.baseWidth;
			const currentRate = parseFloat((window.innerWidth / baseWidth).toFixed(5));
			scale.width = currentRate;
			scale.height = currentRate;
			root.style.transform = `scale(${scale.width}, ${scale.height}) translate(-50%, -50%)`;
		}
	}
};
</script>

<style>
html,
body {
	width: 100%;
	/* height: 100%; */
	position: relative;
}

#app {
	font-family: 'Microsoft YaHei', 'Microsoft YaHei-Regular';
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* width: 19.2rem; */
	/* height: 100%; */

	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transform-origin: left top;
	transition: all 0.28s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue